import { useState } from 'react';
import './Header.css';
import "flag-icons/css/flag-icons.min.css";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBCollapse,
  MDBIcon,
  MDBBtn
} from 'mdb-react-ui-kit';

interface HeaderProps {
  tabChanged(tabName: string): void;
}

export default function Header(headerProps: HeaderProps) {
  const [openNav, setOpenNav] = useState(false);
  const [activeTab, setActiveTab] = useState('home');
  const [activeLanguage, setActiveLanguage] = useState('no');

  const { i18n, t } = useTranslation();

  function changeTab(tabName: string) {
    setActiveTab(tabName);
    headerProps.tabChanged(tabName);
  }

  function changeLanguage() {
    if (activeLanguage === 'no') {
      setActiveLanguage('eng');
      i18n.changeLanguage('eng');
    } else {
      setActiveLanguage('no');
      i18n.changeLanguage('no');
    }
  }

  return (
    <>
      <MDBNavbar expand='lg' light bgColor='light'>
        <MDBContainer fluid>
          <MDBNavbarBrand href='/'>
            <img
              src='omax-consulting-logo.png'
              height='90'
              alt='OMAX Consulting Logo'
              loading='lazy'
            />
          </MDBNavbarBrand>
          <MDBNavbarToggler
            type='button'
            aria-expanded='false'
            aria-label='Toggle navigation'
            onClick={() => setOpenNav(!openNav)}
          >
            <MDBIcon icon='bars' fas />
          </MDBNavbarToggler>
          <MDBCollapse navbar open={openNav} style={{ justifyContent: "right" }}>
            <MDBNavbarNav>
              <MDBNavbarItem>
                <MDBNavbarLink style={{ textAlign: 'right'}} onClick={() => changeTab('home')} className={((activeTab === 'home') ? "active" : "")}>
                  <Link to="/" style={{ fontWeight: activeTab === 'home' ? 'bold' : 'normal' }}>{t('HOME')}</Link>
                </MDBNavbarLink>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <MDBNavbarLink style={{ textAlign: 'right'}} onClick={() => changeTab('about')} className={((activeTab === 'about') ? "active" : "")}>
                  <Link to="/about" style={{ fontWeight: activeTab === 'about' ? 'bold' : 'normal' }}>{t('ABOUT US')}</Link>
                </MDBNavbarLink>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <MDBNavbarLink style={{ textAlign: 'right'}} onClick={() => changeTab('contact')} className={((activeTab === 'contact') ? "active" : "")}>
                  <Link to="/contact" style={{ fontWeight: activeTab === 'contact' ? 'bold' : 'normal' }}>{t('CONTACT US')}</Link>
                </MDBNavbarLink>
              </MDBNavbarItem>
              <MDBNavbarItem style={{ justifyContent: 'right', display: 'flex', alignItems: 'right' }}>
                <MDBBtn onClick={() => changeLanguage()} color='none' style={{ border: 0, backgroundColor: 'white' }}><span className={((activeLanguage === "no") ? "fi fi-sh" : "fi fi-bv")} style={{ scale: '125%' }}></span></MDBBtn>
              </MDBNavbarItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    </>
  );
}
